import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { Link } from 'modules/UI';

import { MARKDOWN_CONTENT_MAX_WIDTH } from '../../constants';

export const P = styled.p`
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
  margin-bottom: ${tokens.space.regular};
  color: ${tokens.colors.grayDarkest};
  font-family: ${tokens.font.family.ifood.body};
  margin: 0;
  margin-bottom: 14px;
  padding-top: 5px;
`;

export const H1 = styled.h1`
  font-size: ${tokens.fontSizes.xl};
  color: ${tokens.colors.black};
  margin-bottom: ${tokens.space.large};
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
`;

export const H2 = styled.h2`
  font-size: ${tokens.fontSizes.xl};
  font-weight: 400;
  color: ${tokens.colors.black};
  margin: 30px 0 20px;
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
`;

export const H3 = styled.h3`
  font-size: ${tokens.fontSizes.l};
  font-weight: 400;
  color: ${tokens.colors.black};
  margin: 10px 0 10px;
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
`;

export const H4 = styled.h4`
  font-size: ${tokens.fontSizes.m};
  color: ${tokens.colors.black};
  margin: 10px 0 10px;
  font-weight: 400;
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
`;

export const H5 = styled.h5`
  margin: 10px 0 10px;
  font-size: ${tokens.fontSizes.m};
  color: ${tokens.colors.black};
  font-weight: 400;
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
`;

export const H6 = styled.h6`
  margin: 10px 0 10px;
  font-size: ${tokens.fontSizes.m};
  color: ${tokens.colors.black};
  font-weight: 400;
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
`;

export const A = styled(Link)`
  font-family: ${tokens.font.family.ifood.body};
`;

const ListStyle = `
  margin-top: 0px;
  padding-left: 28px;
  margin-bottom: ${tokens.space.regular};
`;

export const Ul = styled.ul`
  ${ListStyle};
`;

export const Ol = styled.ol`
  ${ListStyle};
`;

export const Li = styled.li`
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
  max-width: ${MARKDOWN_CONTENT_MAX_WIDTH};
  font-family: ${tokens.font.family.ifood.body};
  color: #545658;
`;

export const Table = styled.table`
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
  display: block;
  border-spacing: 0;
  border-collapse: collapse;
  margin-bottom: ${tokens.space.regular};
`;

export const Thead = styled.thead`
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
`;

export const Tbody = styled.tbody`
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
`;

export const Tr = styled.tr`
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
`;

export const Td = styled.td`
  font-family: ${tokens.font.family.ifood.body};
  color: #545658;
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
  border: 1px solid ${tokens.colors.gray};
  padding: ${tokens.space.smallest} ${tokens.space.regular};
`;

export const Th = styled.th`
  font-family: ${tokens.font.family.ifood.body};
  color: #545658;
  font-size: ${tokens.fontSizes.s};
  white-space: pre-line;
  line-height: ${tokens.lineHeights.m};
  border: 1px solid ${tokens.colors.gray};
  padding: ${tokens.space.smallest} ${tokens.space.regular};
`;
